howspace.widgets.embed = {
    initView: widget => {
        // Post useful info to iFrame for integration purposes
        const embedContent = widget.find('.embed-content');
        if (embedContent.length > 0 && embedContent.data('iframe-element')) {
            embedContent.html(embedContent.data('iframe-element'));
        }

        const iframes = widget.find('iframe');
        if (iframes.length > 0 && embedContent.data('post-data')) {
            const iframe = iframes[0];

            $(iframe).on('load', function() {
                const postData = JSON.parse(atob(embedContent.data('post-data')));
                const payload = {
                    type: 'loaded',
                    data: postData
                };
                iframe.contentWindow.postMessage(payload, document.documentElement.dataset.iframeBaseUri);
            });
        }
    },
    destroyView: widget => {
        // Empty for now.
         const embedContent = widget.find('.embed-content');
        if (embedContent.length > 0 && embedContent.data('iframe-element')) {
            embedContent.html('');
        }
    },
    initEdit: widget => {
        // Embed height input
        const embedHeightInput = widget.find('input[name="embed_height"]');

        embedHeightInput.on('input blur', function(_e) {
            // Validate the embed height input so that it contains only numbers and possibly a percentage character.
            let embedHeightVal = embedHeightInput.val().trim().replace(/[^0-9\.\,\%]/gi, '');
            embedHeightVal = embedHeightVal.replace(/\,/gi, '.');
            embedHeightVal = embedHeightVal.replace(/\.+/gi, '.');
            embedHeightVal = embedHeightVal.replace(/\%+/gi, '%');

            if (embedHeightInput.val() !== embedHeightVal) {
                embedHeightInput.val(embedHeightVal);
            }
        });

        // Embed content textarea
        const embedContentTextarea = widget.find('textarea[name="embed_content"]');
        embedContentTextarea.on('input', function(_e) {
            embedContentTextarea.removeClass('is-invalid');
        });
    },
    destroyEdit: widget => {
        // Empty for now.
    }
};
